import React, {useCallback} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import ModalSimple from '../../global/modal-simple';
import InfoIcon from './shared/info-icon';

const QtyComponent: React.FC = observer(() => {
    const save = (e: React.ChangeEvent<HTMLInputElement>) => {
        s.ps.qty = parseInt(e.target.value, 10);
    };

    if (!s.ready || !s.ui.show_cust) {
        return null;
    }

    return (
        <div className="gray-box">
            <ModalSimple
                id="modal-qty"
                title="Volume Discount Information"
            >
                <div className="modal-qty-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Order Quantity</th>
                                <th>Discount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {s.si &&
                                s.si.VolumeDiscounts &&
                                s.si.VolumeDiscounts?.map(i => (
                                    <tr>
                                        <td>
                                            {i.QtyMin}-{i.QtyMax}
                                        </td>
                                        <td>{i.DiscountPercent}%</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </ModalSimple>

            <div style={{display: 'flex', gap: 5}}>
                <span className="header-std">Quantity</span>
                <div
                    className="info"
                    style={{minWidth: 110}}
                >
                    {s.si && s.si.VolumeDiscounts && s.si.VolumeDiscounts?.length && (
                        <InfoIcon
                            id="modal-qty"
                            ariaLabel="Open information about volume discount for this product"
                            styleBlack={true}
                        />
                    )}
                </div>
            </div>
            <input
                type="number"
                className="form-control ib input-qty"
                style={{width: 125}}
                onChange={save}
                maxLength={5}
                max={50000}
                min={0}
                aria-label="Enter quantity"
            />
        </div>
    );
});

export default QtyComponent;
